export default __webpack_public_path__ + "static/rsz_wojciech-drewczynski-dd69905208dc003cf832539486f153fb.jpg";